import React, { useEffect, useState } from 'react'
import { Provider, useDispatch } from 'react-redux'
import { createStore } from './appStore'
import PageStart from './components/PageStart'
import PageQuestions from './components/PageQuestions'
import PageResults from './components/PageResults'
import pageKeys from './constants/pageKeys'
import { RouterProvider, createHashRouter } from 'react-router-dom'
import { resetUserAnswers } from './reducers/userAnswersReducer'
import PageError from './components/PageError'


const DynamicPages = () => {
    const [currentPage, setCurrentPage] = useState(pageKeys.START)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(resetUserAnswers())
    }, [])

    return (
        pageKeys.QUESTIONS === currentPage ? <PageQuestions /> : <PageStart setCurrentPage={setCurrentPage} />
    )
}

const router = createHashRouter([
    {
        path: "/",
        element: <DynamicPages />,
        errorElement: <PageError />,
    },
    {
        path: "/ergebnisse",
        element: <PageResults />,
        errorElement: <PageError />,
    }
])


const App = ({data}) => (
    <div className="jm-app">
        <Provider store={createStore(data)}>
            <RouterProvider router={router} />
        </Provider>
    </div>
)

export default App